import type { Phase } from "@shared/types";
import { ProjectDocRepository } from "./ProjectDocRepository";
import { defaultPhases } from "@domain/project/projectData";

/**
 * Timeline phases + tasks stored at users/{ownerUid}/projects/{pid}/data/phases.
 */
class PhaseRepository extends ProjectDocRepository<Phase[]> {
  readonly key = "phases";
  readonly defaultValue = defaultPhases as unknown as Phase[];
}

export const phaseRepository = new PhaseRepository();
